import axios from "axios";
import { handleSuccessOne } from "@store/action/GlobalAction";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;

export const getContacts = () => {
  return (dispatch) => {
    axios.get(`${API}${VERSION}/website/contacts`).then((response) => {
      dispatch({
        type: "GET_CONTACT",
        data: response.data,
        allData: response.data,
      });
    });
  };
};
export const editContactWebsite = (data, func) => {
  return (dispatch) => {
    axios
      .put(`${API}${VERSION}/setting/update/contacts/${data.id}`, data)
      .then((response) => {
        dispatch({
          type: "EDIT_CONTACT_WEBSITE_SUCCESS",
          payload: response.data,
        });
        func();
        handleSuccessOne(response.data.message);
        dispatch(getContacts());
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_CONTACT_WEBSITE_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_CONTACT_WEBSITE_FAIL",
              payload: null,
            });
          }, 3000);
        }
      });
  };
};
